<nav *transloco="let t;" class="navbar navbar-expand-lg bg-white py-0 border-bottom d-none d-lg-block">
  <div class="container-fluid h-100">
    <div class="row h-100 w-100">
      <div class="col col-lg-auto px-lg-0 bg-secondary logo-box">
        <div class="row align-items-center h-100">
          <div class="col text-center">
            <a [routerLink]="['/home']" class="navbar-brand">
              <img src='/assets/logo_white.png' alt="" class="sidebar-logo m-auto">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="collapse navbar-collapse">
      <div class="container">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
          <li class="nav-item">
            <div class="vertical-line mx-3"></div>
          </li>
          <!--<li class="nav-item">
          <button (click)="changeTheme()" class="nav-link">
            <i *ngIf="selectedTheme == 'light'" class="fa-solid fa-sun"></i>
            <i *ngIf="selectedTheme !== 'light'" class="fa-solid fa-moon"></i>
          </button>
        </li>-->
        <li class="nav-item" ngbDropdown>
          <a class="nav-link hide-arrow" ngbDropdownToggle role="button" tabindex="0">
            <i class="fa-solid fa-language"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <h6 class="mx-3 text-nowrap">{{t('base.dropdown.selectCTA', {item: t('entities.languages')})}}</h6>
            <hr class="my-1">
            @for (lang of this.langRepo.languagesTranslatable(); track lang; let i = $index) {
              <button (click)="this.langRepo.setSelectedLanguage(lang)"
                [ngClass]="{'active': this.langRepo.activeLanguage()?.id === lang.id}"
                ngbDropdownItem>
                {{ lang.name }}
              </button>
            }
          </div>
        </li>
        <li class="nav-item">
          <div class="vertical-line mx-3"></div>
        </li>
        <li class="nav-item" ngbDropdown>
          <span class="nav-link hide-arrow d-flex align-items-center" ngbDropdownToggle role="button"
            tabindex="0">
            <i class="icon-user me-2" style="font-size: 28px;"></i>
            {{ t('components.menu.greetings', { username: getUserName() || 'User' }) }}
            <i class="fa-solid fa-chevron-down ms-2"></i>
          </span>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @if (isRoutePermitted('profile')) {
              <button [routerLink]="['/profile']" ngbDropdownItem>
                <i class="icon-blank"></i>
                {{ t('components.menu.profile') }}
              </button>
            }
            @if (isRoutePermitted('wallet')) {
              <button [routerLink]="['/wallet']" ngbDropdownItem>
                <i class="icon-wallet"></i>
                {{ t('components.menu.wallet') }}
              </button>
            }
            @if (isRoutePermitted('config')) {
              <button [routerLink]="['config']" ngbDropdownItem>
                <i class="icon-gear"></i>
                {{ t('global.options') }}
              </button>
            }
            <div class="dropdown-divider"></div>
            <button (click)="logout()" ngbDropdownItem>
              <i class="icon-logout"></i>
              {{ t('global.logout') }}
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</nav>
<nav class="bg-secondary border-bottom d-block d-lg-none">
  <div class="container-fluid h-100">
    <div class="row h-100 align-items-center">
      <div class="col-auto">
        <button (click)="openMenuModal()"
          class="btn btn-secondary text-white" type="button">
          <i class="fa-solid fa-bars"></i>
        </button>
      </div>

      <div class="col text-center">
        <a class="navbar-brand" href="'/'">
          <img fetchpriority="high" src='/assets/logo_white.png' alt="" class="sidebar-logo m-auto">
        </a>
      </div>

      <div class="col-auto">
        <button (click)="openUserModal()" class="btn btn-secondary text-white" type="button">
          <i class="fa-solid fa-user"></i>
        </button>
      </div>
    </div>
  </div>
</nav>
